import React, { createContext, useContext } from 'react';
const ModuleContext = /*#__PURE__*/createContext(null);
export const ModuleProvider = _ref => {
  let {
    children,
    module
  } = _ref;
  return /*#__PURE__*/React.createElement(ModuleContext.Provider, {
    value: module
  }, children);
};

// Create the hook to access the current module
export const useCurrentModule = () => {
  const module = useContext(ModuleContext);
  if (!module) {
    throw new Error('useCurrentModule must be used within a ModuleProvider');
  }
  return module;
};
//# sourceMappingURL=ModuleProvider.js.map